import * as React from 'react';

function SignInIcon(props) {
  return (
    <svg width={24} height={24} fill='currentColor' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M2.014 11.99a1 1 0 011-1h9.562l-1.968-2 1.406-1.405 3.72 3.687a1.03 1.03 0 010 1.438l-3.72 3.687-1.406-1.406 1.968-2H3.014a1 1 0 01-1-1zm3-5a4 4 0 014-4h8a4 4 0 014 4v10a4 4 0 01-4 4h-8a4 4 0 01-4-4 1 1 0 012 0 2 2 0 002 2h8a2 2 0 002-2v-10a2 2 0 00-2-2h-8a2 2 0 00-2 2 1 1 0 01-2 0z'
        fill='#fff'
      />
    </svg>
  );
}

export default SignInIcon;
